import React from 'react';

function WhyChooseBpo() {
  const handleTalkClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('bpo-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="why-choose-bpo-section">
      <div className="container why-choose-bpo-container">
        {/* Left Column: Image */}
        <div className="why-choose-bpo-left">
          <div className="why-choose-bpo-img-wrapper">
            <img 
              src="/assets/images/service_approach_professional.png" 
              alt="Why Choose Our BPO Services Company" 
              className="why-choose-bpo-img"
            />
          </div>
        </div>

        {/* Right Column: Content */}
        <div className="why-choose-bpo-right">
          <div className="why-choose-bpo-badge-row">
            <span className="why-choose-bpo-badge">BPO Excellence</span>
            <div className="why-choose-bpo-badge-line"></div>
          </div>

          <h2 className="why-choose-bpo-title">
            Why Choose Our BPO Services Company?
          </h2>

          <p className="why-choose-bpo-desc">
            Experts Communication delivers a complete customer experience solution. We do complete planning for the operational execution. Our team has professionals who can analyze data and implement technology for a smooth and consistent customer journey.
          </p>

          <p className="why-choose-bpo-desc">
            Our inbound and outbound call center helps businesses with effective plans and strategies that can grow the business. We handle everything from customer support and lead generation to market research and sales.
          </p>

          <p className="why-choose-bpo-desc">
            Our business process outsourcing service uses modern technology and proven methodologies to optimize your customer interactions and drive measurable results.
          </p>

          <button className="btn-why-choose-bpo" onClick={handleTalkClick}>
            Let's talk!
          </button>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseBpo;
